// @ts-nocheck
'use strict';
import $ from 'jquery';
import { getCookie } from './utils/get_cookie.js';


const server_msg = $("#server_msg").text()

function setUpUI() {
    console.log('sffss')
    document.addEventListener("keydown", function(event) { //엔터키로 바로
        if (event.key === "Enter") {
            console.log("ddd")
            event.preventDefault(); // 기본 동작 방지

            var username = document.forms[0]["username"].value;
            var password = document.forms[0]["password"].value;

            if (username == "" || password == "") {
                alert("사용자 이름과 비밀번호를 입력하세요.");
                return false; // 폼 제출 중지
            }
            document.querySelector("form").submit(); // 폼 제출
        }
    });

    document.addEventListener('DOMContentLoaded', function() {
        console.log(server_msg)
        if(server_msg != '')
            alert(server_msg);

    });
}


setUpUI();
